import React, { useState, useEffect, useRef } from 'react';
import LoadingSpinner from '../GenericComponents/LoadingSpinner';
import { Document, Page, pdfjs } from 'react-pdf';
import { useReactToPrint } from 'react-to-print';
import authHeader from '../../../services/authheader'
import { Button, Modal } from 'react-bootstrap';
import { FaPrint } from 'react-icons/fa';
import '../Card/ReviewPdf.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
function ExternalFormModal({ show, onHide, type, id, fileName }) {
    const [numPages, setNumPages] = useState(null);
    const [hasLoaded, setHasLoaded] = useState(false);
    const componentRef = useRef();
    const promiseResolveRef = useRef(null);
    const [printLoading, setPrintLoading] = useState(false);

    const [file, setFile] = useState({
        url: "",
        httpHeaders: {}
    })
    const [zoom, setZoom] = useState(1.5);
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        //setPdfLoaded(true);
    }
    useEffect(() => {
        if (show && id) {
            var header = authHeader();
            switch (type) {
                case "experienceApplication":
                    setFile({
                        url: process.env.REACT_APP_APIURL + "/Reports/GetApplicationExperienceVerifierForm?experienceId=" + id,
                        httpHeaders: header
                    })
                    break;
                case "experienceReinstatement":
                    setFile({
                        url: process.env.REACT_APP_APIURL + "/Reports/GetReinstatementExperienceVerifierForm?experienceId=" + id,
                        httpHeaders: header
                    })
                    break;
                case "referencesApplication":
                    setFile({
                        url: process.env.REACT_APP_APIURL + "/Reports/GetApplicationReferenceVerifierForm?referenceId=" + id,
                        httpHeaders: header
                    })
                    break;
                case "referencesReinstatement":
                    setFile({
                        url: process.env.REACT_APP_APIURL + "/Reports/GetReinstatementReferenceVerifierForm?referenceId=" + id,
                        httpHeaders: header
                    })
                    break;
                case "recommendationApplication":
                case "recommendationReinstatement":
                    setFile({
                        url: process.env.REACT_APP_APIURL + "/Reports/GetApplicationRecommendationVerifierForm?recommendationId=" + id,
                        httpHeaders: header
                    })
                    break;
                case "applicationSpAttestation":
                    setFile({
                        url: process.env.REACT_APP_APIURL + "/Reports/GetApplicationSpAttestationForm?spAttestationId=" + id,
                        httpHeaders: header
                    })
                    break;
                case "reinstatementSpAttestation":
                    setFile({
                        url: process.env.REACT_APP_APIURL + "/Reports/GetReinstatementSpAttestationForm?spAttestationId=" + id,
                        httpHeaders: header
                    })
                    break;
                case "renewalSpAttestation":
                    setFile({
                        url: process.env.REACT_APP_APIURL + "/Reports/GetRenewalSpAttestationForm?spAttestationId=" + id,
                        httpHeaders: header
                    })
                    break;
                default:
                    break;
            }
            setHasLoaded(true);
        }
    }, [show])
    useEffect(() => {
        if (printLoading && promiseResolveRef.current) {
            // Resolves the Promise, letting `react-to-print` know that the DOM updates are completed
            promiseResolveRef.current();
        }
    }, [printLoading]);
    const handlePrint = useReactToPrint({
        documentTitle: fileName ? fileName : type,
        contentRef: componentRef,
        onBeforePrint: () => {
            return new Promise((resolve) => {
                promiseResolveRef.current = resolve;
                setPrintLoading(true);
            });
        },
        onAfterPrint: () => {
            promiseResolveRef.current = null;
            setPrintLoading(false);
        }
    });
    return (
        <Modal
            show={show}
            onHide={onHide}
            animation={false}
            size="xl"
            centered
        >
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
                <div className="viewer">
                    {hasLoaded &&
                        <>
                            <div ref={componentRef}>
                                <Document
                                    file={file}
                                    onLoadSuccess={onDocumentLoadSuccess}
                                    loading={<><h4 className={"text-center"}>Loading PDF...</h4><div><LoadingSpinner /></div></>}
                                >
                                    {Array.from(
                                        new Array(numPages),
                                        (el, index) => (
                                            <Page
                                                renderAnnotationLayer={false}
                                                renderTextLayer={false}
                                                key={`page_${index + 1}`}
                                                pageNumber={index + 1}
                                                scale={zoom}
                                            />
                                        ),
                                    )}
                                </Document>
                            </div>
                        </>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handlePrint}><FaPrint /> Print</Button>
                <Button onClick={onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}
export default ExternalFormModal;